<template>
  <div id="tab-answers" v-if="answers" class="answers">
    <ul class="list">
      <li
        v-for="(question, index) in questions"
        :ref="'question' + index"
        :key="index"
        class="item"
        :class="{'is-paused': !is_playing, 'item-selected': currentQuestionIndex === index}"
        @click="play(index)">
        <div class="body" v-if="!isSafari && !isIos">
          <!-- <i class="fa fa-caret-right"></i> -->
          <button 
            class="v-resume-questions__play-button"
            :class="{'v-resume-questions__play-button--active': currentQuestionIndex == index, 'is-paused': is_current_question_paused(index), selected: currentQuestionIndex === index}">
            <svg class="play-pause-icon" width="48" height="48" viewBox="0 0 48 48">
              <circle cx="24" cy="24" r="21.6" fill="white" stroke="#F6F3FA" stroke-dasharray="135.717" stroke-dashoffset="0"></circle>
              <circle cx="24" cy="24" r="21.6" fill="white" stroke="currentColor" stroke-width="1" stroke-dasharray="135.718"  :style="{strokeDashoffset: currentProgress(index)}"/>
            </svg>
            <div class="v-resume-questions__icon-play">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.3947 12.4812L12.128 7.96687C11.6848 7.58694 11 7.90189 11 8.48569V17.5143C11 18.0981 11.6848 18.4131 12.128 18.0331L17.3947 13.5188C17.7129 13.2461 17.7129 12.7539 17.3947 12.4812Z" fill="currentColor"/>
              </svg>
            </div>
            <div class="v-resume-questions__icon-pause">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9" y="7" width="3" height="12" rx="0.68" fill="currentColor"/>
                <rect x="14" y="7" width="3" height="12" rx="0.68" fill="currentColor"/>
              </svg>
            </div>
          </button>
          <div class="q-text" v-html="question.body"></div>
        </div>

        <vrecursive-block v-else :count="questions.length - 1" :current_index="index" :handle_click="first_play_click">
          <div class="body">
            <button 
              class="v-resume-questions__play-button"
              :class="{'v-resume-questions__play-button--active': currentQuestionIndex == index, 'is-paused': is_current_question_paused(index), selected: currentQuestionIndex === index}">
              <svg class="play-pause-icon" width="48" height="48" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="21.6" fill="white" stroke="#AD6CE0" stroke-dasharray="135.717" stroke-dashoffset="0"></circle>
                <circle cx="24" cy="24" r="21.6" fill="white" stroke="currentColor" stroke-width="1" stroke-dasharray="135.718"  :style="{strokeDashoffset: currentProgress(index)}"/>
              </svg>
              <div class="v-resume-questions__icon-play">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.3947 12.4812L12.128 7.96687C11.6848 7.58694 11 7.90189 11 8.48569V17.5143C11 18.0981 11.6848 18.4131 12.128 18.0331L17.3947 13.5188C17.7129 13.2461 17.7129 12.7539 17.3947 12.4812Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="v-resume-questions__icon-pause">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="9" y="7" width="3" height="12" rx="0.68" fill="currentColor"/>
                  <rect x="14" y="7" width="3" height="12" rx="0.68" fill="currentColor"/>
                </svg>
              </div>
            </button>
            <div class="q-text" v-html="question.body"></div>
          </div>
        </vrecursive-block>
      </li>
    </ul>
  </div>
</template>

<script>
  import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js'

  export default {
    name: 'tab-answers',

    mixins: [SafariBrowserDetector],

    props: {
      questions: Array,
      responseId: String,
      durations: Array,
      currentTime: Number,
      questionIndex: Number
    },

    data () {
      return {
        settings: {
          maxScrollbarLength: 600,
          wheelSpeed: 20
        },
        answers: this.answersInit(),
        playclick_count: 0
      }
    },

    computed: {
      currentQuestionIndex () {
        return this.$store.state.vacancy.videointerview.index
      },
      is_playing () {
        return this.$store.getters['vacancy/videointerview/is_playing']
      },
      is_video_started () {
        return this.$store.getters['interview/videointerview/is_video_started']
      },
      vblock() {
        return this.$parent.$refs.vblock
      },
      first_click_was() {
        return this.$store.getters['interview/videointerview/first_click_was']
      },
      playingPercent() {
        if (!this.durations || !this.durations.length) {
          return 100;
        }
        const questionDuration = this.durations.find(item => item.index === this.questionIndex);

        if (!questionDuration) {
          return 100;
        }

        return Math.floor(this.currentTime / (questionDuration.duration / 100));
      }
    },

    methods: {
      has_no_video(index) {
        return this.questions[index].video === null
      },

      is_current_question_paused(index) {
        if (this.currentQuestionIndex === index && !this.is_playing) {
          return true;
        } else {
          return false;
        }
      },

      currentProgress(index) {
        const c = Math.PI * (21.6 * 2);
        if (index !== this.questionIndex) {
          return 0;
        }

        let val = this.playingPercent;
        if (val <= 0) {
          return 0;
        }
        if (val >= 100) {
          return 0;
        }
        const pct = ((100-val)/100)*c - 5;

        if (pct <= 0) {
          return 0;
        }
      
        return pct;
      },

      answersInit () {
        return this.questions.map((answer, index) => {
          return answer.video
            ? {
              content: answer.video.text,
              opened: false
            }
            : {
              content: '',
              opened: false
            }
        })
      },

      toggleAll() {
        let state;
        let opened = this.answers.filter(i => i.opened);
        if(opened.length > 0 && opened.length === this.answers.length) {
          state = false;
        } else if(opened.length > 0) {
          state = false;
        } else {
          state = true;
        }

        this.answers.forEach(i => {
          i.opened = state
        })
      },

      toggleAnswer (index) {
        this.answers[index].opened = !this.answers[index].opened;
      },
      first_play_click (val, current_index) {
        if(this.has_no_video(val)) {
          return;
        }

        if (this.is_video_started || !this.$parent || this.first_click_was) {
          return;
        }
        let refs;
        if(this.$parent.$refs['player_' + val] === undefined) {
          // надо избавиться от этого, надеюсь в 3й задаче по видео добьюсь этого, требуется существенный рефакторинг затронет спец процессы
          refs = this.$parent.$parent.$refs.videointerview_block.$refs.process_layer.$refs;
        } else {
          refs = this.$parent.$refs;
        }
        // На iOs при первом клике на вопрос выполянется мгновенный play, затем pause и unmute всех видео вопросов.
        // Сделано, чтобы на iOs корректно отрабатывало автопереключение видео
        // if (this.isIos || this.isSafari) {
        this.playclick_count = this.playclick_count + 1;

        if(this.questions[val].video === null) {
          return;
        }
        if (val !== current_index) {
          refs['player_' + val][0].player.play();
          refs['player_' + val][0].player.pause();
        }
        refs['player_' + val][0].player.muted(false)
        refs['player_' + val][0].player.volume(1)

        // setTimeout(() => {
        refs['player_' + val][0].player.muted(false)
        refs['player_' + val][0].player.volume(1)
        if (this.playclick_count === this.questions.length - 1) {
          this.$store.commit('interview/videointerview/set_first_click_was', true);
        }

        if (this.playclick_count >= this.questions.length) {
          this.$store.commit('interview/videointerview/toggle_start_video', true);
        }
        // }, 100)
        // }
      },
      /*
      setAnswer (index) {
        this.$store.commit('vacancy/videointerview/setIndex', index)
      },
      */
      play (index) {
        if(this.questions[index].video === null) {
          if (this.isIos || this.isSafari) {
            this.$emit('set_active_answer', index);
          }
          this.$store.commit('vacancy/videointerview/setIndex', index)
          return;
        }

        if (this.isIos || this.isSafari) {
          this.$emit('set_active_answer', index);
          this.$store.commit('vacancy/videointerview/set_playing', !this.is_playing)
        } else {
          this.$store.commit('vacancy/videointerview/set_playing', index !== this.currentQuestionIndex)
        }
        this.$store.commit('vacancy/videointerview/setAutoPlay', true)
        this.$store.commit('vacancy/videointerview/setIndex', index)

      }
    },

    watch: {
      questions () {
        this.answers = this.answersInit()
      }
    },

    beforeDestroy() {
      this.$store.commit('interview/videointerview/clear');
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../styles/colors.scss";

  .scroll-container {
    position: relative;
    max-height: 610px;
  }

  .answers {

    .list {
      list-style-type: none;
      padding: 0;

      .body {
        position: relative;
        margin-bottom: 20px;
        cursor: pointer;
        transition: color .35s ease;
        font-size: 15px;
        line-height: 24px;
        // font-family: 'Euclid Circular A';
        font-style: normal;
        font-weight: normal;
        display: flex;
        align-items: flex-start;
        color: #8D8D8D;

        &.selected {
          color: #555555;
        }

        &:not(.selected):hover {
          color: #555555;
        }
      }

      .item-selected {
        .body {
          color: #555555;
        }
      }
    }
  }

  .play-pause-icon {
    position: absolute;
    left: 0;
    top: 0;
    width: 26px;
    height: 26px;
  }

  .v-resume-questions__play-button {
    position: relative;
		height: 26px;
    width: 26px;
		margin-right: 0.5rem;
    color: #C4B9D3;
    transition: color .35s ease;
    display: flex;
    align-items: center;
    justify-content: center;

		&--active {
      color: #AD6CE0;
    }

    .v-resume-questions__icon-play {
      position: relative;
      z-index:1;
      width: 26px;
      height: 26px;
    }

    .v-resume-questions__icon-pause {
      position: relative;
      z-index:1;
      display: none;
      opacity: 0;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
    }

    svg {
      width: 26px;
      height: 26px;
    }

    &.selected:not(.is-paused) {
      .v-resume-questions__icon-play {
        display: none;
        opacity: 0;
      }

      .v-resume-questions__icon-pause {
        display: flex;
        opacity: 1;
        position: relative;
      }
    }
	}

  .body {
    &:hover {
      .v-resume-questions__play-button {
        color: #AD6CE0;
      }
    }
  }
</style>
